export const ErrorMarker = (props) => (
  <svg
    style={{ ...props?.style }}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='10' cy='10' r='10' fill='#EF4444' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 5C9.44772 5 9 5.44772 9 6V11C9 11.5523 9.44772 12 10 12C10.5523 12 11 11.5523 11 11V6C11 5.44772 10.5523 5 10 5ZM10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14Z'
      fill='white'
    />
  </svg>
);
